"use strict";
/**
 * @module Conversation
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
var conversation_id_1 = require("./../conversation/conversation-id");
/**
 * A Serialiser for {@link ConversationId}s
 */
var CIDSerialiserClass = /** @class */ (function () {
    function CIDSerialiserClass() {
    }
    /**
     * @inheritdoc
     */
    CIDSerialiserClass.prototype.read = function (bis) {
        return new conversation_id_1.ConversationId(Codec.readInt64(bis));
    };
    /**
     * @inheritdoc
     */
    CIDSerialiserClass.prototype.write = function (bos, cid) {
        Codec.writeInt64(bos, cid.val);
    };
    return CIDSerialiserClass;
}());
exports.CIDSerialiserClass = CIDSerialiserClass;
/**
 * The {@link CIDSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.CIDSerialiser = new CIDSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/conversation/conversation-id-serialiser.js
// module id = 47
// module chunks = 1